module.exports = __webpack_public_path__ + "ddf21d61af0d7c09b32118f16fdc6038.jpg";